export const waitForTitle = (
  isExpectedTitle: (title: string) => boolean,
  signal: AbortSignal,
  timeoutMs = 15000
): Promise<void> =>
  new Promise((resolve) => {
    const isSettled = () => isExpectedTitle(document.title)

    if (signal.aborted || isSettled()) {
      resolve()
      return
    }

    const cleanup = () => {
      observer.disconnect()
      clearTimeout(timeout)
      signal.removeEventListener('abort', onSettled)
    }

    const onSettled = () => {
      cleanup()
      resolve()
    }

    const observer = new MutationObserver(() => {
      if (isSettled()) {
        onSettled()
      }
    })

    const timeout = setTimeout(onSettled, timeoutMs)

    signal.addEventListener('abort', onSettled)
    observer.observe(document.head, { childList: true, characterData: true, subtree: true })
  })

export const waitForTitleSettled = (
  previousTitle: string | undefined,
  signal: AbortSignal,
  timeoutMs?: number
): Promise<void> => waitForTitle((title) => title !== '' && title !== previousTitle, signal, timeoutMs)

export const trackAfterTitleSettled = async (
  previousTitle: string | undefined,
  signal: AbortSignal,
  onSettled: (title: string) => void
) => {
  await waitForTitleSettled(previousTitle, signal)

  if (signal.aborted) {
    return
  }

  onSettled(document.title)
}
